import {Routes} from '@angular/router';
import {AdminBinsComponent} from './admin-bins.component';

export const ADMIN_ROUTE_BINS = 'bins';

export const ADMIN_BINS_ROUTES: Routes = [
  {
    path: '',
    component: AdminBinsComponent,
  },
  {
    path: ':id',
    loadComponent: () => import('./bin-details/bin-details.component').then(m => m.BinDetailsComponent)
  }
];
